import React from 'react';
import { Helmet } from 'react-helmet-async';
import OrgCustomCompanySettingsFormContainer from '../../../../containers/organizations/Settings/OrgCustomCompanySettingsFormContainer.jsx';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

const CompanySettings = ({ slug }) => {
  return (
    <>
      <Helmet>
        <title>Organization Settings | ChangeSync</title>
      </Helmet>
      <OrgCustomCompanySettingsFormContainer slug={slug} />
    </>
  );
};

CompanySettings.getInitialProps = ({ query }) => ({
  slug: query.slug,
});

export default requireAuth(withRouterParams(CompanySettings));
